<div class="business-navbar__chip" [ngClass]="{'business-navbar__nav-chip': isNavChip, 'business-navbar__default-chip': isDefaultChip, 'business-navbar__beta-chip': isBetaChip}">{{ text }}</div>
